// export const API_BASE = '//rossnoble-wordpress-api.yfs.io';

// sedhal added
export const API_BASE = 'https://www.admin.rossnoble.com';



// WEBPACK FOOTER //
// ./src/config.js